import React from 'react';
import Buttons from '../../UI/Buttons';
import {parameterizedURLAccessToken,isSet} from '../../../Utils/CommonFunctions';

const AvatarImageUpload = (props)=>{
    const {uploadFileRef,fileClickHandler,fileChangeHandler,imageId,removeHandler,defaultImg,imageBasePath,fieldAttributes,isReadOnly} = props;
    const imageIsExists = (isSet(imageId,null)!==null)?true:false;
    const imagePath = (isSet(imageIsExists,false)===true)?parameterizedURLAccessToken(imageBasePath+imageId):defaultImg;
    return(
        <div className="avatar-upload">
            <div className="avatar-edit">
                {(isReadOnly===false)?
                     <input type='file' 
                     id="avatarImageUpload" 
                     ref={uploadFileRef} 
                     onChange={fileClickHandler} 
                     accept=".png, .jpg, .jpeg" />
                :<></>}
                { fieldAttributes ?
                    fieldAttributes.readOnly === false ?
                    <label 
                        htmlFor="avatarImageUpload" 
                        onClick={fileChangeHandler}>
                    </label>
                    : null
                 :  <label 
                        htmlFor="avatarImageUpload" 
                        onClick={fileChangeHandler}>
                    </label>
                }
            </div>
            <div className="avatar-preview">
                <div 
                    id="imagePreview" 
                    className={(imageIsExists===true)?'imageUploaded':''}  
                    style={{backgroundImage: 'url('+imagePath+')'}} >
                </div>
                <div className="removeImage" style={{display:(imageIsExists===true)?'':'none'}}>
                    <Buttons 
                        buttonList={[{
                            svgIcon:'Delete',
                            clickHandler:removeHandler,
                            attributes:{
                                className:'svgIconFill'
                            }
                    }]} />
                </div>
            </div>
        </div>
    )
}


AvatarImageUpload.defaultProps = {
    defaultImg :'/assets/img/profile2.jpg',
    imageBasePath:'files/download?fileId=',
    isReadOnly:false
}
export default AvatarImageUpload;